import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment, { Moment } from 'moment';

export function calculateCompletionTimeFromNow(startTime: Moment, completionAmount: number) {
  const diffSeconds = moment().diff(startTime, 'seconds');
  // Here we calculate a conservative completion amount
  // This deliberately underestimates progress, especially early on
  // 0.1 -> 0.055
  // 0.5 -> 0.375
  // 0.9 -> 0.855
  const conservativeCompletion = (completionAmount + completionAmount * completionAmount) / 2;
  const endTime = startTime.clone().add(diffSeconds / conservativeCompletion, 'seconds');

  console.log(`Elapsed time: ${diffSeconds}s`);
  console.log(`Conservative completion time: ${endTime.toISOString()}`);

  return moment(endTime).fromNow(true);
}

@Component({
  templateUrl: './progress-modal.component.html',
  standalone: false,
})
export class ProgressModalComponent implements OnInit, OnDestroy {
  @Input() title = '';
  @Input() percent?: number;
  @Input() status = '';

  completionTimeFromNow?: string;

  private interval?: any;

  constructor(
    private activeModal: NgbActiveModal,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    const startTime = moment();
    this.interval = setInterval(() => {
      if (this.percent) {
        this.completionTimeFromNow = calculateCompletionTimeFromNow(startTime, this.percent / 100);
      } else {
        this.completionTimeFromNow = undefined;
      }
      this.cd.markForCheck();
    }, 5000);
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  close() {
    this.activeModal.close();
  }
}
